import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createCartoonStockItem,
  getAllCartoonStocksItems,
  getDataForEdit,
  deleteCartoonStockItem,
  getBillListForVendor,
  getDataForAfterBill,
  adjustCartoonStockItem,
} from "../../store/CartoonStock/CartoonStockSliceApi";

import {
  getAllVendorItems,
  getCartoonListItems,
} from "../../store/AppLevelApi/AppLevelApi";
import { cartoonStockSliceAction } from "../../store/CartoonStock/CartoonStockSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsCartoonStocks } from "../../ConstantData/FormOptions";
//import constant form option to create duplicate field
import { AddMoreFormOptionsCartoonStocks } from "../../ConstantData/AddMoreFormOptions";
//importing inital form data to store value state
import { InitialCartoonStockFormData } from "../../ConstantData/InitialData";
//imporint form data error

//for only adjusted form
import { ErrorCartoonStockFormData } from "../../ConstantData/ErrorOption";
import { adjustedFormCartoonStock } from "../../ConstantData/AdjustedFormOption";
import { InitialAdjustData } from "../../ConstantData/AdjustInitialData";

function CartoonStock() {
  const [showOtherFormBtn, setShowOtherFormBtn] = useState(false); //for only adjust

  const [adjustInitialData, setAdjustInitialData] = useState(InitialAdjustData);

  let newFormOptionsCartoonStock = JSON.parse(
    JSON.stringify(AddMoreFormOptionsCartoonStocks)
  );

  let newFormOptionsCartoonStockText = JSON.parse(
    JSON.stringify(FormOptionsCartoonStocks)
  );
  let newAdjustedFormCartoonStock = JSON.parse(
    JSON.stringify(adjustedFormCartoonStock)
  );
  // let billDataList = useSelector((state) => state.cartoonstock.billDataList);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("name"));
    // dispatch(getAllCartoonStocksItems());
    // dispatch(getAllVendorItems());
    // dispatch(getCartoonListItems());
  }, []);

  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const cartoonStockList = useSelector(
    (state) => state.cartoonstock.cartoonStockList
  );

  //for normal form input data initilization
  const InitialFormDataStore = useSelector(
    (state) => state.cartoonstock.initialData
  );
  //for normal duplicate form input data initilization
  let InitialFormDuplicateDataStore = useSelector(
    (state) => state.cartoonstock.initialDuplicateData
  );

  const cartoonStockEditData = useSelector(
    (state) => state.cartoonstock.dataEdit
  );
  let cartoonStockFormError = useSelector(
    (state) => state.cartoonstock.errorData
  );

  let isError = useSelector((state) => state.cartoonstock.isError);
  cartoonStockFormError = {
    ...ErrorCartoonStockFormData,
    ...cartoonStockFormError,
  };
  const vendorList = useSelector((state) => state.applevel.vendorList);
  const cartoonList = useSelector((state) => state.applevel.cartoonList);
  const billList = useSelector((state) => state.cartoonstock.billList);

  function addOptionForSelectFieldDuplicate(
    FormOption,
    list,
    optionName,
    type
  ) {
    if (type === "duplicate") {
      newFormOptionsCartoonStock = FormOption.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    } else {
      newAdjustedFormCartoonStock = adjustedFormCartoonStock.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    }
  }
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsCartoonStockText = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }

  if (vendorList.length > 0) {
    // to chage subquality option coming from server4
    addOptionForSelectField(
      newFormOptionsCartoonStockText,
      vendorList,
      "Vendor"
    );
  }

  if (cartoonList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      newFormOptionsCartoonStock,
      cartoonList,
      "Cartoon Type",
      "duplicate"
    );
  }

  if (billList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      adjustedFormCartoonStock,
      billList,
      "Bill Number",
      "adjusted"
    );
  } else {
    addOptionForSelectFieldDuplicate(
      adjustedFormCartoonStock,
      [],
      "Bill Number",
      "adjusted"
    );
  }

  const setDataForAdjust = (type) => {
    if (vendorList.length > 0) {
      addOptionForSelectFieldDuplicate(
        adjustedFormCartoonStock,
        vendorList,
        "Vendor",
        "adjusted"
      );
    }
  };

  const inputAdjustHandler = (name, value) => {
    //only for adjust not need for all

    const formData = JSON.parse(JSON.stringify(adjustInitialData)); //deep copy
    if (name === "bill_number") {
      setShowOtherFormBtn((prevState) => !prevState);
      dispatch(getDataForAfterBill(value.value));
    }
    // if (name === "vendor") dispatch(getBillListForVendor(value.value));
    formData[name] = value;
    setAdjustInitialData(formData);
  };

  const headTitleLabel = headTitle(FormOptionsCartoonStocks, [
    "Cartoon Type",
    "Quantity",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialCartoonStockFormData}
      getDataForEdit={getDataForEdit}
      delteFun={deleteCartoonStockItem}
      createFun={createCartoonStockItem} //create function coming from store
      FormOptions={newFormOptionsCartoonStockText}
      NewFormOptions={newFormOptionsCartoonStock}
      OptionName="Create Cartoon Stock"
      OptionNameList="Cartoon Stock"
      generalList={cartoonStockList}
      headTitle={headTitleLabel}
      EditData={cartoonStockEditData}
      isError={isError}
      ErrorData={cartoonStockFormError}
      InitialFormDataStore={InitialFormDataStore}
      InitialFormDuplicateDataStore={InitialFormDuplicateDataStore}
      setErrorData={cartoonStockSliceAction.setErrorData}
      generalModuleList={vendorList} //list to add different module
      isNotDeleteBtn={true}
      extraAddBtn={true}
      extraButtonText={"Add Cartoon"}
      FormStyle={"!w-[60%] !h-[40rem] custom-scroll-for-nav overflow-y-scroll "}
      secondCreateBtn={false} // to create second button to add extra form
      isSuccess={isSuccess}
      needAdjust={true} //it is used if there is no edit but need adjust
      adjustedFormStock={adjustedFormCartoonStock} //it is used if there is no edit but need adjust
      setDataForAdjust={setDataForAdjust}
      inputAdjustHandler={inputAdjustHandler} //it is used if there is no edit but need adjust
      InitialAdjustData={adjustInitialData} //it is used if there is no edit but need adjust
      listForLength={{ billList }}
      showOtherFormBtn={showOtherFormBtn} // //it is used if there is no edit but need adjust
      createAdjust={adjustCartoonStockItem}
      notShowEditBtn={true} //use when you dont need edit btn
    />
  );
}

export default CartoonStock;
